import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  question: '¿Para qué grados sirve?',
  answer: 'Para toda la primaria argentina de 1º a 6º grado. Cada grado tiene su carpeta con 32 lecturas y actividades adaptadas al nivel.'
}, {
  question: '¿Puedo comprar solo un grado?',
  answer: 'Sí. Podés comprar el pack completo por $19.990 ARS o un grado individual por $6.500 ARS. Los 3 bonos se incluyen en ambas opciones.'
}, {
  question: '¿El material está alineado al Diseño Curricular?',
  answer: 'Sí. Cada lectura fue diseñada respetando los NAP y el Diseño Curricular argentino vigente.'
}, {
  question: '¿Cuándo recibo el material?',
  answer: 'En el momento. Recibís el link de descarga en tu mail inmediatamente después del pago.'
}, {
  question: '¿Qué pasa si no me gusta?',
  answer: 'Tenés 7 días para probarlo. Si no estás satisfecha te devolvemos el 100% sin preguntas.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-20 bg-slate-50" data-id="element-77">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-78">
        <div className="text-center mb-12" data-id="element-79">
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#1E3A5F] mb-4" data-id="element-80">
            PREGUNTAS FRECUENTES
          </h2>
          <div className="w-24 h-1.5 bg-[#F59E0B] mx-auto rounded-full" data-id="element-81"></div>
        </div>

        <div className="space-y-4" data-id="element-82">
          {faqs.map((faq, index) => <div key={index} className={`bg-white rounded-2xl border ${openIndex === index ? 'border-[#F59E0B] shadow-md' : 'border-slate-200 shadow-sm'} overflow-hidden transition-all duration-200`} data-id="element-83">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => toggleFaq(index)} data-id="element-84">
                <span className="font-bold text-[#1E3A5F] text-lg pr-4" data-id="element-85">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUp className="w-6 h-6 text-[#F59E0B] flex-shrink-0" data-id="element-86" /> : <ChevronDown className="w-6 h-6 text-slate-400 flex-shrink-0" data-id="element-87" />}
              </button>

              {openIndex === index && <div className="px-6 pb-5 text-slate-600 text-lg leading-relaxed" data-id="element-88">
                  {faq.answer}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}